import { Link } from 'react-router';
import { Card } from '#client/components/ui/Card';
import { Page } from '#client/components/ui/Page';
import { routes } from '#client/lib/routes';

export function NotFoundPage() {
  return (
    <Page title="Page not found">
      <Card>
        <p className="text-fg-muted">That page does not exist.</p>
        <p className="mt-4">
          <Link to={routes.dashboard}>Back to the dashboard</Link>
        </p>
      </Card>
    </Page>
  );
}
